export default "__VITE_ASSET__D9QNwz34__"